import { createApiClient } from '../../../api';

import { passcodeErrorFrom } from './errors';

export const { request } = createApiClient({ toError: passcodeErrorFrom });
